import TonWeb from "tonweb";
import React, { useState, useEffect } from "react";
import { TonConnect } from "@tonconnect/sdk";
import {Element, scroller} from 'react-scroll';
import Styles from './styles.module.scss';
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// // import { TonConnectButton, useTonAddress } from "@tonconnect/ui-react";
import { useTonAddress } from "@tonconnect/ui-react";
import MainS1 from "../../components/mainS1";
import MainS2 from "../../components/mainS2";
import MainS3 from "../../components/mainS3";
import MainS4 from "../../components/mainS4";
import {useDispatch, useSelector} from "react-redux";
import {setLinkScrollStatus} from "../../store/main/action";

const tonConnect = new TonConnect(); // ✅ Теперь тоже после импортов

const MainPage = () => {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const userFriendlyAddress = useTonAddress();

    const linkScrollStatus = useSelector(store => store.main.linkScrollStatus);

    console.log(userFriendlyAddress);
    // const authorizationStatus = useSelector(store => store.main.authorizationStatus);
    // const userData = useSelector(store => store.cabinet.userData);

    const [balance, setBalance] = useState(null);

    const scrollHandler = (element) =>{
        scroller.scrollTo(element, {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
        })
    }

    console.log(balance)

    // useEffect(() => {
    //     if (authorizationStatus && userData) {
    //         navigate('/event');
    //     }
    // }, [authorizationStatus, userData, navigate]);

    useEffect(()=>{
        if (linkScrollStatus){
            scrollHandler(linkScrollStatus);
            dispatch(setLinkScrollStatus(false));
        }
    },[dispatch, linkScrollStatus])

    useEffect(() => {
        async function fetchBalance() {
            try {
                // ✅ Проверяем, есть ли подключенный адрес
                if (!userFriendlyAddress) {
                    console.log("Кошелек не подключен");
                    return;
                }

                // ✅ Создаем HTTP провайдер для получения баланса
                const tonweb = new TonWeb(new TonWeb.HttpProvider("https://toncenter.com/api/v2/jsonRPC"));

                // ✅ Получаем баланс (TON хранится в нано-коинах, делим на 10^9)
                const balanceRaw = await tonweb.getBalance(userFriendlyAddress);
                setBalance(balanceRaw / 10 ** 9); // Переводим в TON

                console.log(`Баланс кошелька ${userFriendlyAddress}:`, balanceRaw / 10 ** 9);
            } catch (error) {
                console.error("Ошибка получения баланса:", error);
                setBalance(null);
            }
        }
        console.log("Подключенные кошельки:", tonConnect.wallet);
        fetchBalance();
    }, [userFriendlyAddress]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                {/*<PublicHeader/>*/}
                <MainS1/>
                <MainS2/>
                <MainS3/>
                <Element name="ideology">
                    <MainS4/>
                </Element>
                {/*<PublicFooter/>*/}
                {/*<TonConnectButton />*/}
                {/*<div style={{background: 'white'}}>*/}
                {/*    {userFriendlyAddress ? (*/}
                {/*        <p>Баланс: {balance !== null ? `${balance} TON` : "Загрузка..."}</p>*/}
                {/*    ) : (*/}
                {/*        <p>Подключите TON Space кошелек</p>*/}
                {/*    )}*/}
                {/*</div>*/}
                {/*<div style={{background: 'white'}}>*/}
                {/*    <LoginButton*/}
                {/*        botUsername="FTFLocalBot"*/}
                {/*        onAuthCallback={(data) => {*/}
                {/*            console.log(data);*/}
                {/*            // call your backend here to validate the data and sign in the user*/}
                {/*        }}*/}
                {/*        showAvatar={false}*/}
                {/*    />*/}
                {/*</div>*/}

            </div>
        </section>
    );
};

export default MainPage;
